<template>
  <div>
    <details-bar
      type="campaign"
      :permissions="permissions"
    />
    <donation-table filter="campaign" />
  </div>
</template>

<script>
import DetailsBar from "@/app/donations-website/components/DetailsBar";
import DonationTable from "@/app/donations-website/components/DonationsTable";

export default {
  name: "CampaignsDetails",
  components: {
    DetailsBar,
    DonationTable
  },
  data() {
    return {
      permissions: {
        add: "store_campaigns",
        update: "update_campaigns",
        delete: "destory_campaigns"
      }
    };
  },
};
</script>
